import { Reveal } from "@/components/MaskedLines";

const BADGES = [
  { id: "about-feature-badge-1984", title: "Est. 1984", desc: "Founded in Gianyar, Bali — and still producing there today." },
  { id: "about-feature-badge-package", title: "Full-package production", desc: "Pattern, sourcing, cutting, sewing, finishing and packing under one roof." },
  { id: "about-feature-badge-location", title: "Bali production hub", desc: "Close to the island's textile suppliers and export routes." },
];

export const About = () => (
  <section id="about" data-testid="about-section" className="mt-24 bg-[#f5f5f7] py-24 sm:mt-32 sm:py-32">
    <div className="mx-auto max-w-5xl px-5 sm:px-6">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-20">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#86868b]">About CV Meranggi Jaya</p>
          <h2
            data-testid="about-title"
            className="mt-4 text-3xl font-semibold leading-[1.12] tracking-tight text-[#1d1d1f] sm:text-4xl lg:text-5xl"
          >
            Heritage & quality.
            <br />
            Born in Gianyar, Bali.
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p data-testid="about-description" className="text-base leading-relaxed text-[#1d1d1f]/80 sm:text-lg lg:pt-12">
            CV Meranggi Jaya was founded in 1984 in Gianyar — a regency long known for its artisans. For more than
            four decades, the Meranggi workshop has combined Balinese craftsmanship with disciplined, modern garment
            production.
            <br />
            <br />
            Every order, from a single sample to a full production run, moves through the same measured process:
            draft, cut, sew, finish, inspect. That is how we have kept the trust of our clients — by making exactly
            what we promise.
          </p>
        </Reveal>
      </div>

      <div className="mt-16 grid grid-cols-1 gap-4 sm:grid-cols-3 sm:gap-5">
        {BADGES.map((b, i) => (
          <Reveal key={b.id} delay={0.1 * i}>
            <div data-testid={b.id} className="h-full rounded-[24px] bg-white p-8">
              <p className="text-xl font-semibold tracking-tight text-[#1d1d1f]">{b.title}</p>
              <p className="mt-3 text-sm leading-relaxed text-[#86868b]">{b.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
